// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.add_newsConatiner {
  width: 100%;
  height: fit-content;
}
.newTypeGroup {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 1rem;
}

.newTypeGroup > div {
    
    display: flex;
    align-items: center;
    font-size: 20px;
    font-weight: 500;
    color: #000000;
    gap: 12px;
}
.newTypeGroup > div > input {
    width: 24px;
    height: 24px;
}
.news_heading{
  font-size: 20px;
}

.article{
  font-size: 16px;
}
.youtube{
  font-size: 16px;
}

.newsTitle p{
font-size: 16px;
}

/* Editor css */


.ql-snow .ql-picker.ql-header{
  width: 122px !important;
}

.p-editor-toolbar .ql-formats {
  display: flex !important;
  align-items: center;
  gap: 10px; /* Add some spacing between the buttons */
}

/* Styles for the header dropdown */
.p-editor-toolbar .ql-header {
  border: 1px solid #ccc;
  border-radius: 4px;
  padding: 5px;
  font-size: 14px;
}

/* Styles for the size dropdown */
.p-editor-toolbar .ql-size {
  border: 1px solid #ccc;
  border-radius: 4px;
  padding: 5px;
  font-size: 14px;
}

/* Styles for the bold button */
.p-editor-toolbar .ql-bold {
  background-color: #f1f1f1;
  border: 1px solid #ccc;
  border-radius: 4px;
  padding: 5px;
}

/* Styles for the italic button */
.p-editor-toolbar .ql-italic {
  background-color: #f1f1f1;
  border: 1px solid #ccc;
  border-radius: 4px;
  padding: 5px;
}

/* Styles for the underline button */
.p-editor-toolbar .ql-underline {
  background-color: #f1f1f1;
  border: 1px solid #ccc;
  border-radius: 4px;
  padding: 5px;
}
#ql-picker-options-1 {
  background: white;
}

#ql-picker-options-0 {
  background: white;
}

/* Styles for the link button */
.p-editor-toolbar .ql-link {
  background-color: #f1f1f1;
  border: 1px solid #ccc;
  border-radius: 4px;
  padding: 5px;
}


.ql-snow .ql-picker{
  height: auto !important;
}
/* Styles for the image button */
.p-editor-toolbar .ql-image {
  background-color: #f1f1f1;
  border: 1px solid #ccc;
  border-radius: 4px;
  padding: 5px;
}
.ql-header.ql-picker{
  height:auto !important ;
}
/* Add hover effects */
.p-editor-toolbar .ql-header:hover,
.p-editor-toolbar .ql-size:hover,
.p-editor-toolbar .ql-bold:hover,
.p-editor-toolbar .ql-italic:hover,
.p-editor-toolbar .ql-underline:hover,
.p-editor-toolbar .ql-link:hover,
.p-editor-toolbar .ql-image:hover {
  background-color: #e0e0e0;
}

/* Add active state styles */
.p-editor-toolbar .ql-header.ql-active,
.p-editor-toolbar .ql-size.ql-active,
.p-editor-toolbar .ql-bold.ql-active,
.p-editor-toolbar .ql-italic.ql-active,
.p-editor-toolbar .ql-underline.ql-active,
.p-editor-toolbar .ql-link.ql-active,
.p-editor-toolbar .ql-image.ql-active {
  background-color: #d0d0d0;
}
`, "",{"version":3,"sources":["webpack://./src/Pages/News/AddNews/AddNews.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,SAAS;AACX;;AAEA;;IAEI,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,SAAS;AACb;AACA;IACI,WAAW;IACX,YAAY;AAChB;AACA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;;AAEA;AACA,eAAe;AACf;;AAEA,eAAe;;;AAGf;EACE,uBAAuB;AACzB;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;EACnB,SAAS,EAAE,yCAAyC;AACtD;;AAEA,mCAAmC;AACnC;EACE,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;EACZ,eAAe;AACjB;;AAEA,iCAAiC;AACjC;EACE,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;EACZ,eAAe;AACjB;;AAEA,+BAA+B;AAC/B;EACE,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;AACd;;AAEA,iCAAiC;AACjC;EACE,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;AACd;;AAEA,oCAAoC;AACpC;EACE,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA,+BAA+B;AAC/B;EACE,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;AACd;;;AAGA;EACE,uBAAuB;AACzB;AACA,gCAAgC;AAChC;EACE,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,uBAAuB;AACzB;AACA,sBAAsB;AACtB;;;;;;;EAOE,yBAAyB;AAC3B;;AAEA,4BAA4B;AAC5B;;;;;;;EAOE,yBAAyB;AAC3B","sourcesContent":[".add_newsConatiner {\n  width: 100%;\n  height: fit-content;\n}\n.newTypeGroup {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 1rem;\n}\n\n.newTypeGroup > div {\n    \n    display: flex;\n    align-items: center;\n    font-size: 20px;\n    font-weight: 500;\n    color: #000000;\n    gap: 12px;\n}\n.newTypeGroup > div > input {\n    width: 24px;\n    height: 24px;\n}\n.news_heading{\n  font-size: 20px;\n}\n\n.article{\n  font-size: 16px;\n}\n.youtube{\n  font-size: 16px;\n}\n\n.newsTitle p{\nfont-size: 16px;\n}\n\n/* Editor css */\n\n\n.ql-snow .ql-picker.ql-header{\n  width: 122px !important;\n}\n\n.p-editor-toolbar .ql-formats {\n  display: flex !important;\n  align-items: center;\n  gap: 10px; /* Add some spacing between the buttons */\n}\n\n/* Styles for the header dropdown */\n.p-editor-toolbar .ql-header {\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  padding: 5px;\n  font-size: 14px;\n}\n\n/* Styles for the size dropdown */\n.p-editor-toolbar .ql-size {\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  padding: 5px;\n  font-size: 14px;\n}\n\n/* Styles for the bold button */\n.p-editor-toolbar .ql-bold {\n  background-color: #f1f1f1;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  padding: 5px;\n}\n\n/* Styles for the italic button */\n.p-editor-toolbar .ql-italic {\n  background-color: #f1f1f1;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  padding: 5px;\n}\n\n/* Styles for the underline button */\n.p-editor-toolbar .ql-underline {\n  background-color: #f1f1f1;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  padding: 5px;\n}\n#ql-picker-options-1 {\n  background: white;\n}\n\n#ql-picker-options-0 {\n  background: white;\n}\n\n/* Styles for the link button */\n.p-editor-toolbar .ql-link {\n  background-color: #f1f1f1;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  padding: 5px;\n}\n\n\n.ql-snow .ql-picker{\n  height: auto !important;\n}\n/* Styles for the image button */\n.p-editor-toolbar .ql-image {\n  background-color: #f1f1f1;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  padding: 5px;\n}\n.ql-header.ql-picker{\n  height:auto !important ;\n}\n/* Add hover effects */\n.p-editor-toolbar .ql-header:hover,\n.p-editor-toolbar .ql-size:hover,\n.p-editor-toolbar .ql-bold:hover,\n.p-editor-toolbar .ql-italic:hover,\n.p-editor-toolbar .ql-underline:hover,\n.p-editor-toolbar .ql-link:hover,\n.p-editor-toolbar .ql-image:hover {\n  background-color: #e0e0e0;\n}\n\n/* Add active state styles */\n.p-editor-toolbar .ql-header.ql-active,\n.p-editor-toolbar .ql-size.ql-active,\n.p-editor-toolbar .ql-bold.ql-active,\n.p-editor-toolbar .ql-italic.ql-active,\n.p-editor-toolbar .ql-underline.ql-active,\n.p-editor-toolbar .ql-link.ql-active,\n.p-editor-toolbar .ql-image.ql-active {\n  background-color: #d0d0d0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
